
























































import Loader from '@/contexts/frontend/Loader.vue'

export default {
  components: {
    loader: Loader
  },
  props: {
    clientId: String
  },
  data: function() {
    return {
      client: {
        id: '',
        name: '',
        slug: ''
      },
      loading: false
    }
  },
  mounted() {
    this.loading = true
    this.$api.clientAdmin
      .GetClient(this.clientId)
      .then(result => (this.client = result[0]))
      .finally(() => (this.loading = false))
  },
  methods: {
    saveClient() {
      this.$api.clientAdmin
        .UpdateClient(this.client)
        .then(() => this.$router.push({ name: 'settings-clients-list' }))
    }
  }
}
